enum PageId {
    DASHBOARD= 'dashboard',
    FOOTPRINT= 'footprint'
}

export default PageId;